<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-11">
          <strong class="card-title mb-3">{{(id !== '')? 'Edit' : 'Add'}} Theme</strong>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div>
        <div class="mb5"></div>
        <!-- <vform :formData="editForm" :fields="fields" :submitCallback="showSmallModal"/> -->
        <form class="form-horizontal" @onsubmit.prevent action>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group" :class="{'has-error': validation.hasError('name')}">
                <label class="form-control-label">Theme Name</label>
                <input
                  type="text"
                  class="form-control inmarginbtm"
                  placeholder="Name"
                  value
                  v-model="name"
                />
                <div class="error">{{ validation.firstError('name') }}</div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group" :class="{'has-error': validation.hasError('description')}">
                <label class="form-control-label">Description</label>
                <!-- <textarea
                  class="form-control inmarginbtm"
                  placeholder="Description"
                  value
                  v-model="description"
                ></textarea> -->
                 <vue-ckeditor id="description" v-model="description" :config="config" />
                <div class="error">{{ validation.firstError('description') }}</div>
              </div>
            </div>
            <div class="col-md-12">
              <div
                class="form-group"
                :class="{'has-error': validation.hasError('longDescription')}"
              >
                <label class="form-control-label">Long Description</label>
                <!-- <textarea
                  class="form-control inmarginbtm"
                  placeholder="Long Description"
                  value
                  v-model="longDescription"
                ></textarea> -->
                 <vue-ckeditor id="long_description" v-model="longDescription" :config="config" />
                <div class="error">{{ validation.firstError('longDescription') }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" :class="{'has-error': validation.hasError('sortOrder')}">
                <label for="sort-order" class="form-control-label">Sort Order</label>
                <input class="form-control" type="number" v-model="sortOrder" />
                <div class="error">{{ validation.firstError('sortOrder') }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" :class="{'has-error': validation.hasError('status')}">
                <label for="select-status" class="form-control-label">Status</label>
                <select id="select-status" class="form-control" v-model="status">
                  <option value>Select Status</option>
                  <option
                    v-for="(f, index) in userStatus"
                    :value="f.id"
                    :key="index+f.value"
                  >{{f.value}}</option>
                </select>
                <div class="error">{{ validation.firstError('status') }}</div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group" :class="{'has-error': validation.hasError('companies')}">
                <label class="form-control-label">Select Companies</label>
                <!-- @select="getSelectedCompanies()" -->
                <v-multiselect
                  v-model="selComps"
                  :options="companyList"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select Companies"
                  label="companyname"
                  track-by="companyname"
                  :preselect-first="false"
                  select-label
                  selectedLabel
                  deselectLabel
                  :custom-label="multiSelName"
                  :max-height="500"
                >
                  <template slot="selection" slot-scope="{ values, search, isOpen }">
                    <span
                      class="multiselect__single"
                      v-if="values.length && !isOpen"
                    >{{values.length}} selected</span>
                    <!-- <span
                      v-for="(v, index) in values"
                      v-bind:key="'v'+index"
                    >{{ v.companyname }} {{(index===(values.length-1))? '':', '}}</span>-->
                  </template>
                </v-multiselect>
                <input
                  type="hidden"
                  class="form-control inmarginbtm"
                  placeholder="companies"
                  v-model="companies"
                />
                <div class="error">{{ validation.firstError('companies') }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="table-responsive" v-if="selComps !== '' || selComps.length>0">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Selected Companies</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tr v-for="(co, ind) in selComps" v-bind:key="co.co_code">
                    <td>{{co.companyname}}</td>
                    <td>
                      <i @click="removeComp(ind)" class="fa fa-remove flat-color-4"></i>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="col-md-4"></div>
            <div class="col-md-1 pull-right">
              <div class="form-group">
                <button type="button" @click="addTheme" class="btn btn-primary">Save</button>
              </div>
            </div>
            <div class="col-md-1 pull-right">
              <div class="form-group">
                <button
                  type="button"
                  @click="cancel"
                  class="btn btn-outline-primary pull-right"
                >Cancel</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
// import PinCheck from "@/components/PinCheck.vue";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Datepicker from "vuejs-datepicker";
import SimpleVueValidation from "simple-vue-validator";
var Validator = SimpleVueValidation.Validator;
import VueCkeditor from "vue-ckeditor2";

export default {
  components: { Datepicker, VueCkeditor },
  mixins: [commonMixins],
  created() {
    if (this.$route.params.id) {
      this.id = parseInt(this.$route.params.id);
      this.getThemeDetails();
    } else {
      this.getCompaniesMaster();
    }
  },
  validators: {
    name: function(value) {
      return Validator.value(value).required();
    },
    description: function(value) {
      return Validator.value(value).required();
    },
    longDescription: function(value) {
      return Validator.value(value).required();
    },
    status: function(value) {
      return Validator.value(value).required();
    },
    sortOrder: function(value) {
      return Validator.value(value).required();
    },
    companies: function(value) {
      return Validator.value(value).required();
    }
  },
  data() {
    return {
      themeDetails: {},
      id: "",
      name: "",
      description: "",
      longDescription: "",
      sortOrder: 0,
      status: 1,
      companies: [],
      companyList: [],
      selComps: "",
      userStatus: [{ id: 0, value: "Inactive" }, { id: 1, value: "Active" }],
      config: {
        toolbar: [
          {
            name: "snddocument",
            items: [
              "Source",
              "-",
              "Save",
              "NewPage",
              "DocProps",
              "Preview",
              "Print",
              "-",
              "Templates"
            ]
          },
          { name: "clipboard", items: ["Undo", "Redo"] },
          {
            name: "editing",
            items: [
              "Find",
              "Replace",
              "-",
              "SelectAll",
              "-",
              "SpellChecker",
              "Scayt"
            ]
          },
          {
            name: "forms",
            items: [
              "Form",
              "Checkbox",
              "Radio",
              "TextField",
              "Textarea",
              "Select",
              "Button",
              "ImageButton",
              "HiddenField"
            ]
          },
          "/",
          {
            name: "basicstyles",
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript",
              "-",
              "RemoveFormat"
            ]
          },
          {
            name: "paragraph",
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
              "CreateDiv",
              "-",
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock",
              "-",
              "BidiLtr",
              "BidiRtl"
            ]
          },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
          {
            name: "insert",
            items: [
              "Image",
              // "Flash",
              "Table",
              "HorizontalRule",
              "Smiley",
              "SpecialChar",
              "PageBreak",
              "Iframe"
            ]
          },
          { name: "styles", items: ["Styles", "Format", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "tools", items: ["Maximize", "ShowBlocks"] }
        ]
      }
    };
  },
  methods: {
    addTheme() {
      var _this = this;
      this.submitted = true;
      this.companies = this.selComps;
      // this.getSelectedCompanies();
      if (this.selComps !== "" && this.selComps.length > 0) {
        this.$validate().then(success => {
          // console.log('on success ' + success)
          if (success) {
            const data = {
              id: _this.id,
              name: _this.name,
              description: _this.description,
              longDescription: _this.longDescription,
              sortOrder: _this.sortOrder,
              status: _this.status,
              companies: _this.selComps
            };
            console.log("Submit data", data);
            http.post("theme/add", data, (error, response) => {
              if (response.ok === 1) {
                _this.$toastr.success("Theme saved successfully!", {});
                _this.$router.push({ name: "themes" });
              } else {
                _this.$toastr.error(
                  "Oops, Something went wrong! Please try again later.",
                  {}
                );
              }
            });
          }
        });
      }
    },
    clearForm() {
      this.themeDetails = {};
      (this.name = ""),
        (this.description = ""),
        (this.longDescription = ""),
        (this.status = 1),
        (this.sortOrder = 0),
        (this.companies = "");
    },
    updateTheme() {},
    getThemeDetails() {
      var _this = this;
      http.post("theme/get/1", { id: _this.id }, (error, response) => {
        if (response.data && response.data.length) {
          _this.getCompaniesMaster();
          _this.themeDetails = response.data[0];
          _this.name = _this.themeDetails.name;
          _this.description = _this.themeDetails.description;
          _this.longDescription = _this.themeDetails.longDescription;
          _this.sortOrder = _this.themeDetails.sortOrder;
          _this.status = _this.themeDetails.status;
          _this.companies = _this.themeDetails.companies;
          _this.selComps = _this.themeDetails.companies;
        } else {
          this.$toastr.error('Oops, something went wrong!');
          this.$router.push({
            name: "themes"
          });
        }
      });
    },
    getCompaniesMaster() {
      let _this = this;
      http.get("getCompanyMaster", {}, function(error, response) {
        _this.companyList = response;
      });
    },
    getCompanies() {},
    multiSelName({ companyname }) {
      return `${companyname}`;
    },
    getSelectedCompanies() {
      console.log(this.selComps);
      if (this.selComps.length > 0) {
        this.selComps.forEach(ele => {
          this.companies.push(ele.co_code);
        });
        console.log(this.companies);
      }
    },
    cancel() {
      this.$router.push({
        name: "themes"
      });
    },
    removeComp(ind) {
      this.selComps.splice(ind, 1);
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.clear-fix {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/themes/add-theme.vue